import MainLayout from "../../layouts/MainLayout";
import { ReactComponent as NotFound } from '../../assets/images/404.svg';
import { Container } from "reactstrap";
import DefaultButton from "../../components/Buttons/Default";
import { Link } from "react-router-dom";

function NotFoundPage() {
  return(
    <MainLayout>
      <section className="py-5">
        <Container className="text-center pt-5">
          <NotFound />

          <h3 className="mt-5 mb-5">الصفحة غير موجودة</h3>

          <Link to={'/'}>
            <DefaultButton size="lg" className="mb-4">العودة للرئيسية</DefaultButton>
          </Link>
        </Container>
      </section>
    </MainLayout>
  );
}

export default NotFoundPage;